import { render } from "./PedidosBudget.vue?vue&type=template&id=3c850e33&scoped=true"
import script from "./PedidosBudget.vue?vue&type=script&lang=ts"
export * from "./PedidosBudget.vue?vue&type=script&lang=ts"

import "./PedidosBudget.vue?vue&type=style&index=0&id=3c850e33&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3c850e33"

export default script